class OfflineError extends Error {
  constructor(message) {
    super(message);
    this.name = "OfflineError";
  }
}

class PendingSyncError extends Error {
  constructor(message, options) {
    super(message, options);
    this.name = "PendingSyncError";
  }
}

export { OfflineError, PendingSyncError };
